import { locale } from '../services/translator';
import { webServiceHost } from '../services/dior';

export const FAVORITE_CDC_COOKIE = 'cdc_wishlist_items_id';
export const FAVORITE_PCD_COOKIE = 'pcd_wishlist_items_id';

export const FAVORITE_CDC_URLS = {
  development: `/fixtures/favorite-cdc.json`,
  test: `/fixtures/favorite-cdc.json`,
  preProduction: `${webServiceHost}/couture/${locale}/ws/v1/wishlistDetails?limit=5`,
  production: `${webServiceHost}/couture/${locale}/ws/v1/wishlistDetails?limit=5`
};

export const FAVORITE_PDC_URLS = {
  development: `/fixtures/favorite-pcd.json`,
  test: `/fixtures/favorite-pcd.json`,
  preProduction: `${webServiceHost}/beauty/${locale}/ws/v1/wishlistDetails.html?market=FR`,
  production: `${webServiceHost}/beauty/${locale}/ws/v1/wishlistDetails.html?market=FR`
};



// WEBPACK FOOTER //
// ./src/settings/favorite.js